import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMySuggestions = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 2H15.8C15.4 0.6 14.2 0 12 0C9.8 0 8.7 0.6 8.2 2H4.5C3.7 2 3 2.7 3 3.5V22.5C3 23.3 3.7 24 4.5 24H19.5C20.3 24 21 23.3 21 22.5V3.5C21 2.7 20.3 2 19.5 2ZM12 1C14.1 1 14.8 1.5 15 3H9C9.2 1.5 9.9 1 12 1ZM20 22.5C20 22.8 19.8 23 19.5 23H4.5C4.2 23 4 22.8 4 22.5V3.5C4 3.2 4.2 3 4.5 3H8C8 3.2 8 3.3 8 3.5C8 3.8 8.2 4 8.5 4H15.5C15.8 4 16 3.8 16 3.5C16 3.3 16 3.2 16 3H19.5C19.8 3 20 3.2 20 3.5V22.5Z",
			fill: "#F5F4F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 8H14.5C14.8 8 15 7.8 15 7.5C15 7.2 14.8 7 14.5 7H9.5C9.2 7 9 7.2 9 7.5C9 7.8 9.2 8 9.5 8Z",
			fill: "#F5F4F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 10H7.5C7.2 10 7 10.2 7 10.5C7 10.8 7.2 11 7.5 11H16.5C16.8 11 17 10.8 17 10.5C17 10.2 16.8 10 16.5 10Z",
			fill: "#F5F4F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 12H7.5C7.2 12 7 12.2 7 12.5C7 12.8 7.2 13 7.5 13H16.5C16.8 13 17 12.8 17 12.5C17 12.2 16.8 12 16.5 12Z",
			fill: "#F5F4F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 14H7.5C7.2 14 7 14.2 7 14.5C7 14.8 7.2 15 7.5 15H16.5C16.8 15 17 14.8 17 14.5C17 14.2 16.8 14 16.5 14Z",
			fill: "#F5F4F3"
		})
	]
});
export default SvgMySuggestions;
